import { updateBreakdownCover } from '../../slices/coverDetails';
import { AppDispatch } from '../../store';
import { Risk } from '../../types/policy';
import { RiskClassCode, RiskDetailBPKGeneralPropertyMachineryBreakdown } from '../../types/risk';
import { getRiskByClassCode } from './getRiskByClassCode';

export const updateBreakdownCoverAction = ({
  risks,
  dispatch,
}: {
  risks: Risk[];
  dispatch: AppDispatch;
}) => {
  const portableItemsRisk = getRiskByClassCode(risks, RiskClassCode.PortableItems);
  const portableItemsRiskDetails = (
    portableItemsRisk?.riskDetail as RiskDetailBPKGeneralPropertyMachineryBreakdown | undefined
  )?.riskBPKGeneralPropertyMachineryBreakdown;
  const machineryBreakdown = portableItemsRiskDetails?.machineryBreakdown;
  // machineryBreakdown might be set even if not selected. Check if any values is set to determine if machineryBreakdown
  // has been selected
  if (
    !machineryBreakdown ||
    (!machineryBreakdown.machineryBreakDownExcess &&
      !machineryBreakdown.machineryBlanketSI &&
      !machineryBreakdown.machineryBlanketNumberOfItems &&
      !machineryBreakdown.deteriorationOfStockSI)
  ) {
    return;
  }
  dispatch(
    updateBreakdownCover({
      sumInsured: machineryBreakdown.machineryBlanketSI,
      numberOfItems: machineryBreakdown.machineryBlanketNumberOfItems,
      deteriorationOfStock: machineryBreakdown.deteriorationOfStockSI,
    })
  );
};
